// import React from 'react'

// const Success = () => {
//   return (
//     <div className='bg-green-200 w-full max-w-md m-auto h-36 flex justify-center items-center font-semibold text-lg '>
//         <p>Payment successful</p>
//     </div>
//   )
// }

// export default Success



import React, { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { BsLightningChargeFill, BsCheckCircleFill } from 'react-icons/bs';
import { MdCancel } from 'react-icons/md';

export function Success() {
  const [show, setShow] = useState(false);
  useEffect(() => { const t = setTimeout(() => setShow(true), 80); return () => clearTimeout(t); }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden"
      style={{ background: 'linear-gradient(160deg, var(--bg-void) 0%, var(--bg-deep) 100%)' }}
    >
      {/* Green glow */}
      <div className="pointer-events-none absolute"
           style={{ top: '30%', left: '50%', transform: 'translateX(-50%)',
             width: 500, height: 500,
             background: 'radial-gradient(circle, rgba(52,211,153,0.10) 0%, transparent 70%)',
             filter: 'blur(80px)' }} />

      <div
        className={`
          glass-hi rounded-3xl p-12 max-w-md w-full text-center
          transition-all duration-700
          ${show ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}
        `}
        style={{ border: '1px solid rgba(52,211,153,0.25)' }}
      >
        {/* Icon ring */}
        <div className="flex justify-center mb-6">
          <div
            className="w-20 h-20 rounded-full flex items-center justify-center"
            style={{ background: 'rgba(52,211,153,0.12)', border: '1px solid rgba(52,211,153,0.3)' }}
          >
            <BsCheckCircleFill className="text-4xl animate-pulse" style={{ color: 'var(--green)' }} />
          </div>
        </div>

        <h1 className="font-display text-3xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
          PAYMENT <span style={{ color: 'var(--green)' }}>SUCCESSFUL</span>
        </h1>
        <p className="text-sm mb-8 font-mono" style={{ color: 'var(--text-muted)' }}>
          Your order has been confirmed. Thank you!
        </p>

        <Link to="/">
          <button className="btn-primary px-8 py-3 rounded-xl flex items-center gap-2 mx-auto">
            <BsLightningChargeFill />
            Continue Shopping
          </button>
        </Link>
      </div>
    </div>
  );
}

export function Cancel() {
  const [show, setShow] = useState(false);
  useEffect(() => { const t = setTimeout(() => setShow(true), 80); return () => clearTimeout(t); }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden"
      style={{ background: 'linear-gradient(160deg, var(--bg-void) 0%, var(--bg-deep) 100%)' }}
    >
      {/* Red glow */}
      <div className="pointer-events-none absolute"
           style={{ top: '30%', left: '50%', transform: 'translateX(-50%)',
             width: 500, height: 500,
             background: 'radial-gradient(circle, rgba(255,77,109,0.08) 0%, transparent 70%)',
             filter: 'blur(80px)' }} />

      <div
        className={`
          glass-hi rounded-3xl p-12 max-w-md w-full text-center
          transition-all duration-700
          ${show ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}
        `}
        style={{ border: '1px solid rgba(255,77,109,0.2)' }}
      >
        <div className="flex justify-center mb-6">
          <div
            className="w-20 h-20 rounded-full flex items-center justify-center"
            style={{ background: 'var(--coral-dim)', border: '1px solid rgba(255,77,109,0.3)' }}
          >
            <MdCancel className="text-4xl" style={{ color: 'var(--coral)' }} />
          </div>
        </div>

        <h1 className="font-display text-3xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
          PAYMENT <span style={{ color: 'var(--coral)' }}>CANCELLED</span>
        </h1>
        <p className="text-sm mb-8 font-mono" style={{ color: 'var(--text-muted)' }}>
          No charges were made. You can try again anytime.
        </p>

        <div className="flex gap-3 justify-center">
          <Link to="/cart">
            <button className="btn-ghost px-6 py-3 rounded-xl">Back to Cart</button>
          </Link>
          <Link to="/">
            <button className="btn-primary px-6 py-3 rounded-xl flex items-center gap-2">
              <BsLightningChargeFill /> Home
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Success;